import * as THREE from "three";

export function createSky() {
  const group = new THREE.Group();
  const skyMat = new THREE.ShaderMaterial({
    side: THREE.BackSide,
    depthWrite: false,
    uniforms: {
      top: { value: new THREE.Color(0x0a1424) },
      mid: { value: new THREE.Color(0x151018) },
      bot: { value: new THREE.Color(0x1a140e) },
    },
    vertexShader: `
      varying vec3 vW;
      void main(){
        vec4 w = modelMatrix * vec4(position,1.0);
        vW = position;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
      }
    `,
    fragmentShader: `
      varying vec3 vW;
      uniform vec3 top; uniform vec3 mid; uniform vec3 bot;
      void main(){
        float h = normalize(vW).y;
        vec3 col = mix(bot, mid, smoothstep(-0.15, 0.08, h));
        col = mix(col, top, smoothstep(0.08, 0.72, h));
        float stars = step(0.996, fract(sin(dot(normalize(vW).xz * 240.0, vec2(12.9898,78.233))) * 43758.5453));
        col += stars * smoothstep(0.15, 0.6, h) * 0.55;
        gl_FragColor = vec4(col, 1.0);
      }
    `,
  });
  const sky = new THREE.Mesh(new THREE.SphereGeometry(180, 32, 20), skyMat);
  group.add(sky);

  const moon = new THREE.Mesh(
    new THREE.CircleGeometry(6.5, 32),
    new THREE.MeshBasicMaterial({ color: 0xdce8f5, fog: false })
  );
  moon.position.set(-70, 55, 40);
  moon.lookAt(0, 0, 40);
  group.add(moon);
  const glow = new THREE.Mesh(
    new THREE.CircleGeometry(14, 32),
    new THREE.MeshBasicMaterial({ color: 0x8aa0c0, transparent: true, opacity: 0.18, fog: false, depthWrite: false })
  );
  glow.position.copy(moon.position);
  glow.lookAt(0, 0, 40);
  group.add(glow);
  return group;
}

export function makeFlare(color: number, size = 1.8) {
  const c = document.createElement("canvas");
  c.width = c.height = 128;
  const g = c.getContext("2d")!;
  const grd = g.createRadialGradient(64, 64, 2, 64, 64, 62);
  grd.addColorStop(0, "rgba(255,255,255,0.95)");
  grd.addColorStop(0.2, "rgba(255,220,160,0.55)");
  grd.addColorStop(0.55, "rgba(255,160,60,0.12)");
  grd.addColorStop(1, "rgba(0,0,0,0)");
  g.fillStyle = grd;
  g.fillRect(0, 0, 128, 128);
  const tex = new THREE.CanvasTexture(c);
  const mat = new THREE.SpriteMaterial({
    map: tex,
    color,
    transparent: true,
    depthWrite: false,
    blending: THREE.AdditiveBlending,
    fog: false,
  });
  const s = new THREE.Sprite(mat);
  s.scale.setScalar(size);
  return s;
}
